import script from "./SentimentStatBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SentimentStatBar.vue?vue&type=script&setup=true&lang=js"

import "./SentimentStatBar.vue?vue&type=style&index=0&id=59179e45&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59179e45"]])

export default __exports__